<div class="stepper-container">
  <div class="header">
    <img
      src="../../../../assets/Logos/zentra_logo-removebg-preview 1.png"
      alt="zentra green logo"
      width="50"
      height="50"
    />
    <h1>Zentra Subscription Configuration</h1>
  </div>

  <hr />

  <mat-horizontal-stepper [linear]="isLinear" #stepper>
    <!-- Step 1: Select Product -->
    <mat-step [stepControl]="firstFormGroup">
      <form [formGroup]="firstFormGroup" (click)="markAllControlsTouched()">
        <ng-template matStepLabel>Products</ng-template>

        <div class="sub-identifier-section">
          <div class="section-header">
            <mat-icon>label</mat-icon>
            <h3>Subscription Identifier</h3>
          </div>
          <mat-form-field class="full-width">
            <mat-label>Subscription Identifier</mat-label>
            <input
              matInput
              formControlName="subscriptionIdentifier"
              placeholder="Enter Property Name or any other unique identifier for ease of identification"
              maxlength="100"
            />
          </mat-form-field>
        </div>
        <div><h2>Select A Product</h2></div>
        <div class="products">
          <div class="product-cards">
            <mat-card
              *ngFor="let product of products"
              class="product-card"
              [ngClass]="{
                selected: selectedProduct?.product?.id === product.product.id
              }"
              (click)="selectProduct(product)"
            >
              <mat-card-header>
                <mat-card-title>{{ product.product.name }}</mat-card-title>
                <mat-card-subtitle>{{
                  product.product.productFamily.name
                }}</mat-card-subtitle>
              </mat-card-header>
              <mat-card-content>
                <p>
                  Description:
                  {{
                    product.product.description || "No description available."
                  }}
                </p>
              </mat-card-content>
            </mat-card>
            <ng-template #noProducts>
              <p>No products available.</p>
            </ng-template>
          </div>
        </div>
      </form>
    </mat-step>

    <!-- Step 2: Customer Info -->
    <mat-step [stepControl]="secondFormGroup">
      <form (click)="markAllControlsTouched()" [formGroup]="secondFormGroup">
        <ng-template matStepLabel>Configuration</ng-template>
        <div><h2>Configure Subscription</h2></div>
        <div class="ci-inputs">
          <div class="plan-section">
            <div class="section-header">
              <mat-icon>dashboard_customize</mat-icon>
              <h3>
                Plan:
                {{ selectedProduct?.product?.name || "No product selected" }}
              </h3>
            </div>
            <div class="plan-details">
              <div class="components-container" formArrayName="components">
                <div
                  class="component-card"
                  *ngFor="
                    let componentControl of components.controls;
                    let i = index
                  "
                  [formGroupName]="i"
                >
                  <h3>Component Details</h3>

                  <mat-form-field class="full-width">
                    <mat-label>Component</mat-label>
                    <mat-select
                      formControlName="component"
                      [displayWith]="displayComponentName"
                      (selectionChange)="onComponentChange($event.value, i)"
                      required
                    >
                      <mat-option
                        *ngFor="let option of componentOptions"
                        [value]="option"
                        [disabled]="isComponentSelected(option, i)"
                      >
                        {{ option.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field class="full-width">
                    <mat-label>Quantity</mat-label>
                    <input
                      matInput
                      type="number"
                      formControlName="allocatedQuantity"
                      placeholder="Enter quantity"
                      required
                    />
                    <mat-error
                      *ngIf="
                        componentControl
                          .get('allocatedQuantity')
                          ?.hasError('min')
                      "
                    >
                      Quantity must be at least 1.
                    </mat-error>
                    <mat-error
                      *ngIf="
                        componentControl
                          .get('allocatedQuantity')
                          ?.hasError('notInteger')
                      "
                    >
                      Quantity must be a whole number.
                    </mat-error>
                  </mat-form-field>

                  <ng-container *ngIf="connectComponentService.isConnectComponent(componentControl)">
                    <mat-form-field class="full-width">
                      <mat-label>Number of Units</mat-label>
                      <input
                        matInput
                        type="number"
                        min="0"
                        formControlName="numberOfUnits"
                        required
                      />
                      <mat-error
                        *ngIf="
                          componentControl
                            .get('numberOfUnits')
                            ?.hasError('min')
                        "
                      >
                        Number of Units cannot be negative.
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field class="full-width">
                      <mat-label>Number of Perimeter/Amenity</mat-label>
                      <input
                        matInput
                        type="number"
                        min="0"
                        formControlName="numberOfPerimeterAmenity"
                        required
                      />
                      <mat-error
                        *ngIf="
                          componentControl
                            .get('numberOfPerimeterAmenity')
                            ?.hasError('min')
                        "
                      >
                        Number of Perimeter/Amenity cannot be negative.
                      </mat-error>
                    </mat-form-field>
                  </ng-container>

                  <div class="component-price">
                    <h4 *ngIf="!componentControl.get('useCustomPrice')?.value">
                      Price per Unit:
                      {{componentControl.get('component')?.value?.prices?.[0]?.formattedUnitPrice ?? ''}}
                    </h4>

                    <div class="custom-price">
                      <mat-checkbox
                        formControlName="useCustomPrice"
                        (change)="toggleCustomPrice(i)"
                      >
                        Use Custom Price
                      </mat-checkbox>

                      <mat-form-field
                        class="full-width"
                        *ngIf="componentControl.get('useCustomPrice')?.value"
                      >
                        <mat-label>Set Custom Price Per Unit</mat-label>
                        <input
                          matInput
                          type="number"
                          formControlName="customPrice"
                          placeholder="Enter custom price"
                          [ngClass]="{
                            'input-error':
                              componentControl.get('customPrice')?.invalid &&
                              componentControl.get('customPrice')?.touched
                          }"
                          required
                        />
                        <mat-error
                          *ngIf="
                            componentControl.get('customPrice')?.hasError('min')
                          "
                        >
                          Price must be at least $1.
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="action-buttons">
                    <button mat-button color="primary" (click)="addComponent()">
                      <mat-icon>add</mat-icon>
                      Add Component
                    </button>
                    <button
                      mat-button
                      color="warn"
                      (click)="removeComponent(i)"
                    >
                      <mat-icon>remove</mat-icon>
                      Remove Component
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Price Section -->
          <div class="price-section">
            <div class="section-header">
              <mat-icon>attach_money</mat-icon>
              <h3>Price</h3>
            </div>
            <div class="price-details">
              <div>
                <h3>Total Price: ${{ totalPrice }}</h3>
              </div>

              <div *ngFor="let item of selectedComponents; let i = index">
                <h4>
                  {{ item.component.name }}: {{ item.quantity }} x
                  {{
                    components.at(i).get("useCustomPrice")?.value
                      ? (components.at(i).get("customPrice")?.value
                        | currency: "USD":"symbol":"1.2-2")
                      : item.component.prices[0].formattedUnitPrice || "N/A"
                  }}
                </h4>
              </div>
            </div>
          </div>
        </div>

        <!-- Integrator Information -->
        <div class="bottom-section">
          <div class="integrator-section" [formGroup]="metafieldsGroup">
            <div class="section-header">
              <mat-icon>info_outline</mat-icon>
              <h3>Project Details</h3>
            </div>
            <!-- <mat-form-field class="full-width">
              <mat-label>Integrator Name</mat-label>
              <input
                matInput
                formControlName="integratorName"
                placeholder="...Joe Smith"
              />
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>Integrator Email</mat-label>
              <input
                matInput
                formControlName="integratorEmail"
                placeholder="...joe@test.com"
              />
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>Integrator Phone</mat-label>
              <input
                matInput
                formControlName="integratorPhone"
                placeholder="555 555 5555"
                appPhoneFormat
              />
              <mat-error
                *ngIf="
                  metafieldsGroup.get('integratorPhone')?.hasError('minlength')
                "
              >
                Phone number must be at least 10 digits long, excluding spaces
                and symbols.
              </mat-error>
            </mat-form-field> -->
            <mat-form-field class="full-width">
              <mat-label
                >What type of project is this?</mat-label
              >
              <mat-select formControlName="projectType" required>
                <mat-option value="competitor_takeover">Competitor Takeover</mat-option>
                <mat-option value="mechanical_upgrade">Mechanical Upgrade</mat-option>
                <mat-option value="new">New Construction</mat-option>
                <mat-option value="not_on_zentra">Not on Zentra</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>Is this an Engage Migration?</mat-label>
              <mat-select formControlName="engageMigration" required>
                <mat-option value="yes">Yes</mat-option>
                <mat-option value="no">No</mat-option>
              </mat-select>
            </mat-form-field>
            <div
              *ngIf="metafieldsGroup.get('engageMigration')?.value === 'yes'"
            >
              <mat-form-field class="full-width">
                <mat-label>Expected Migration Start Date</mat-label>
                <mat-datepicker-toggle
                  matPrefix
                  [for]="migrationPicker"
                ></mat-datepicker-toggle>
                <input
                  matInput
                  [matDatepicker]="migrationPicker"
                  formControlName="expectedMigrationDate"
                />
                <mat-datepicker #migrationPicker></mat-datepicker>
                <mat-error
                  *ngIf="
                    metafieldsGroup
                      .get('expectedMigrationDate')
                      ?.hasError('pastDate')
                  "
                >
                  Date cannot be in the past.
                </mat-error>
              </mat-form-field>
              <mat-form-field class="full-width">
                <mat-label>Engage Site Name (if known)</mat-label>
                <input matInput formControlName="engageSiteName" />
              </mat-form-field>
              <mat-form-field class="full-width">
                <mat-label>Engage Site ID (if known)</mat-label>
                <input matInput formControlName="engageSiteId" />
              </mat-form-field>
            </div>
            <mat-form-field class="full-width">
              <mat-label>Expected Occupancy Date</mat-label>
              <mat-datepicker-toggle
                matPrefix
                [for]="occPicker"
              ></mat-datepicker-toggle>
              <input
                matInput
                [matDatepicker]="occPicker"
                formControlName="expectedOccupancyDate"
                required
              />
              <mat-datepicker #occPicker></mat-datepicker>
              <mat-error
                *ngIf="
                  metafieldsGroup
                    .get('expectedOccupancyDate')
                    ?.hasError('pastDate')
                "
              >
                Date cannot be in the past.
              </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>Expected Implementation Start Date</mat-label>
              <mat-datepicker-toggle
                matPrefix
                [for]="implPicker"
              ></mat-datepicker-toggle>
              <input
                matInput
                [matDatepicker]="implPicker"
                formControlName="implementationStartDate"
                required
              />
              <mat-datepicker #implPicker></mat-datepicker>
              <mat-error
                *ngIf="
                  metafieldsGroup
                    .get('implementationStartDate')
                    ?.hasError('pastDate')
                "
              >
                Date cannot be in the past.
              </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>Integrator Name</mat-label>
              <input
                matInput
                formControlName="integratorName"
                placeholder="...Joe Smith"
              />
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>Integrator Email</mat-label>
              <input
                matInput
                formControlName="integratorEmail"
                placeholder="...joe@test.com"
              />
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>Integrator Phone</mat-label>
              <input
                matInput
                formControlName="integratorPhone"
                placeholder="555 555 5555"
                appPhoneFormat
              />
              <mat-error
                *ngIf="
                  metafieldsGroup.get('integratorPhone')?.hasError('minlength')
                "
              >
                Phone number must be at least 10 digits long, excluding spaces
                and symbols.
              </mat-error>
            </mat-form-field>
          </div>

          <div class="bottom-right-section">
            <!-- Purchaser Email -->
            <div class="purchaser-section">
              <div class="section-header">
                <mat-icon>person</mat-icon>
                <h3>Purchaser Email</h3>
              </div>
              <mat-form-field class="full-width">
                <mat-label>Enter Email Address</mat-label>
                <input
                  matInput
                  formControlName="purchaserEmail"
                  placeholder="...Enter purchaser email"
                  required
                />
              </mat-form-field>
              <h5>
                *Enter the email of the person who will be paying for/managing
                the subscription. They will receive an invite in their email to
                log in and pay*
              </h5>

              <div *ngIf="purchaserEmailErrorMessage" class="error-message">
                <mat-icon>error_outline</mat-icon>
                <div class="error-content">
                  <strong>Unable to Send Invitation</strong>
                  <p>{{ purchaserEmailErrorMessage }}</p>
                  <ul class="failed-emails-list">
                    <li>{{ failedPurchaserEmail }}</li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="purchaser-section">
              <div class="section-header">
                <mat-icon>calendar_month</mat-icon>
                <h3>Billing Renewal Date</h3>
              </div>
              <mat-form-field class="full-width">
                <mat-datepicker-toggle
                  matPrefix
                  [for]="picker"
                ></mat-datepicker-toggle>
                <mat-label>Set Billing Renewal Date</mat-label>
                <input
                  matInput
                  [matDatepicker]="picker"
                  formControlName="next_billing_at"
                  placeholder="Click calendar to launch date picker"
                />
                <mat-error
                  *ngIf="
                    secondFormGroup
                      .get('next_billing_at')
                      ?.hasError('notFutureDate')
                  "
                >
                  Date must be in the future.
                </mat-error>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
              <h5>
                *Set the billing renewal date only if you want to override the
                default behavior. Otherwise, the plan will start when the
                purchaser pays, and the renewal date will automatically be
                determined based on the plan's duration. For example, "Zentra
                Annual" paid on June 1, 2025, will renew on June 1, 2026.*
              </h5>
            </div>
          </div>
        </div>
      </form>
    </mat-step>
  </mat-horizontal-stepper>

  <div class="stepperControls padding s6 all">
    <button
      mat-button
      class="previousStepButton"
      routerLink="/zentra-subscriptions"
    >
      Home
    </button>
    <div class="previous-save-button-container">
      <div class="button-container">
        <button
          mat-button
          class="previousStepButton"
          (click)="goToPreviousStep()"
          [style.visibility]=""
          *ngIf="(stepper?.selectedIndex ?? 0) > 0"
        >
          Previous
        </button>
        <button
          mat-raised-button
          class="nextStepButton"
          (click)="goToNextStep()"
          [disabled]="!isCurrentStepValid()"
          *ngIf="shouldShowNextButton()"
        >
          Next
        </button>
      </div>
      <button
        mat-raised-button
        class="nextStepButton"
        (click)="submitForm()"
        [disabled]="!isCurrentStepValid() || isSaveButtonDisabled"
        *ngIf="shouldShowSaveButton()"
      >
        Save Subscription
      </button>
    </div>
  </div>
</div>
